<template>
  <span>{{formattedDate}}</span>
</template>

<script>
  import strftime from 'strftime';

  export default {
    props: {
      date: {
        type: Date,
        required: true,
      }
    },
    computed: {
      formattedDate() {
        const GMTtime = strftime.timezone(new Date().getTimezoneOffset());
        return GMTtime('%-m/%-d/%Y', this.date);
      }
    }
  }
</script>
